<div class="lead-container">
  <app-documents-uploader
    [showWarningFSChecks]="showWarningFSChecks"
    [showWarningFSvsComp]="showWarningFSvsComp"
    [showWarningCYvsPY]="showWarningCYvsPY"
    [retrievedFiles]="retrievedFiles"
    (filesEmitter)="getUploadedFiles($event)"
  ></app-documents-uploader>

  <div class="bg-image"></div>

  <app-agent-five-home-cards
    [filesToRun]="filesToRun"
    (changeToTabEmitter)="toggleToTabNumber($event)"
    (showWarningForFSChecks)="onShowWarningForFSChecks($event)"
    (showWarningForFSvsComp)="onShowWarningForFSvsComp($event)"
    (showWarningForCYvsPY)="onShowWarningForCYvsPY($event)"
    (retrievedFilesEmitter)="onSetRetrievedFiles($event)"
  ></app-agent-five-home-cards>
</div>
